export const daysConstant = [
  {title:"Monday",id:1}  ,
  {title:"Tuesday",id:2}  ,
  {title:"Wednesday",id:3},
  {title:"Thursday",id:4},
  {title:"Friday",id:5},
  {title:"Saturday",id:6},
  {title:"Sunday",id:0},
];
